module.exports = __webpack_public_path__ + "static/media/gem-green.1aeee276.svg";